<template>
    <div class="card">
        <div class="card-content">
            <div class="content">
                <h3>Device Information</h3>

                <div class="columns is-vcentered">
                    <div class="column is-2">
                        <b-field label="All Models">
                            <b-switch v-model="allModels"></b-switch>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Models">
                            <b-taginput
                                v-model="models.tags"
                                :data="models.filteredTags"
                                autocomplete
                                :allow-new="false"
                                :open-on-focus="true"
                                :disabled="allModels"
                                field="name"
                                icon="label"
                                type="is-primary"
                                placeholder="Select models"
                                @typing="getFilteredModelTags"
                                @add="modelTagsUpdated"
                                @remove="modelTagsUpdated">
                            </b-taginput>
                        </b-field>
                    </div>
                </div>

                <b-field label="Storage">
                    <b-taginput
                        v-model="storage.tags"
                        :data="storage.filteredTags"
                        autocomplete
                        :allow-new="false"
                        :open-on-focus="true"
                        field="name"
                        icon="label"
                        type="is-primary"
                        placeholder="Select storage size(s)"
                        @typing="getFilteredStorageTags"
                        @add="storageTagsUpdated"
                        @remove="storageTagsUpdated">
                    </b-taginput>
                </b-field>

                <div class="columns is-vcentered">
                    <div class="column is-2">
                        <b-field label="Broken Devices">
                            <b-switch v-model="brokenActive"></b-switch>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Wanted defects">
                            <b-taginput
                                v-model="defects.wantedDefects"
                                :data="defects.filteredTags"
                                autocomplete
                                :allow-new="false"
                                :open-on-focus="true"
                                field="name"
                                icon="label"
                                type="is-primary"
                                :disabled="!brokenActive"
                                placeholder="Select defects"
                                @typing="getFilteredDefectsTags"
                                @add="defectTagsUpdated"
                                @remove="defectTagsUpdated">
                            </b-taginput>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Unwanted Defects">
                            <b-taginput
                                v-model="defects.blacklistedDefects"
                                :data="defects.filteredTags"
                                autocomplete
                                :allow-new="false"
                                :open-on-focus="true"
                                field="name"
                                icon="label"
                                type="is-primary"
                                :disabled="!brokenActive"
                                placeholder="Select defects"
                                @typing="getFilteredDefectsTags"
                                @add="defectTagsUpdated"
                                @remove="defectTagsUpdated">
                            </b-taginput>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import modelsData from '@/assets/data/iphone/models.json'
import defectsData from '@/assets/data/iphone/defects.json'
import storageData from '@/assets/data/iphone/storage.json'

export default {
    name: "iPhoneSearchSettings",
    data() {
        return {
            models: {
                filteredTags: modelsData,
                tags: [],
            },
            allModels: true,
            brokenActive: false,
            defects: {
                filteredTags: defectsData,
                wantedDefects: [],
                blacklistedDefects: [],
            },
            storage: {
                filteredTags: storageData,
                tags: [],
            },
        }
    },
    computed: {
        defectTagsInUse: function () {
            return this.defects.wantedDefects.concat(this.defects.blacklistedDefects);
        }
    },
    methods: {
        filterTags(tags, existing_tags, text) {
            let available_tags = tags.filter(x => !existing_tags.includes(x));

            return available_tags.filter((option) => {
                return option.name
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            });
        },
        getFilteredModelTags(text) {
            this.models.filteredTags = this.filterTags(modelsData, this.models.tags, text);
        },
        modelTagsUpdated() {
            this.models.filteredTags = modelsData.filter(x => !this.models.tags.includes(x));
        },
        getFilteredStorageTags(text) {
            this.storage.filteredTags = this.filterTags(storageData, this.storage.tags, text);
        },
        storageTagsUpdated() {
            this.storage.filteredTags = storageData.filter(x => !this.storage.tags.includes(x));
        },
        getFilteredDefectsTags(text) {
            this.defects.filteredTags = this.filterTags(defectsData, this.defectTagsInUse, text);
        },
        defectTagsUpdated() {
            this.defects.filteredTags = defectsData.filter(x => !this.defectTagsInUse.includes(x));
        },
        getQueryParams() {
            let queryName = this.getiPhoneModelsString();

            if (this.storage.tags.length > 0) {
                queryName = queryName + " / " + this.getListFromTags(this.storage.tags);
            }

            if (this.defects.wantedDefects.length > 0) {
                queryName = queryName + " / " + this.getListFromTags(this.defects.wantedDefects);
            }

            if (this.defects.blacklistedDefects.length > 0) {
                let tags = this.defects.blacklistedDefects.map(defect => {
                    return {
                        id: defect.id,
                        name: "<s>" + defect.name + "</s>"
                    }
                });

                queryName = queryName + " / " + this.getListFromTags(tags);
            }

            return {
                title: queryName
            }
        },
        getiPhoneModelsString() {
            if (this.allModels) {
                return "All iPhones";
            } else {
                return this.getListFromTags(this.models.tags);
            }
        },
        getListFromTags(tags) {
            let tagsList = "";

            tags.forEach(tag => {
                tagsList = tagsList + tag.name + ", "
            });

            // Remove the last ", "
            return tagsList.substring(0, tagsList.length - 2);
        }
    }
};

</script>

<style scoped>


</style>